module.exports = __webpack_public_path__ + "img/down2.900703c8.png";